import React from "react";
import { useState } from "react";
import { RESERVE_OPTIONS } from "../constrant/leasing.ct.options";
import Select from "react-select";
import classNames from "classnames";
import Swal from "sweetalert2";
import { Auth } from "aws-amplify";
import { useSelector } from "react-redux";
import { EmitterStatus } from "../../../event";
import API from "../api/api.main";
import { checkRole } from "utils/role";

function FootageReserve({
  formQuery,
  onChangeSelect,
  selectedRows = [],
  setSelectedRows,
  refetch,
}) {
  const [loadingReserve, setLoadingReserve] = useState(false);
  const { user } = useSelector((state) => state.initializeApp);

  const onClickReserve = (typeReserve) => async () => {
    try {
      setLoadingReserve(true);
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            for (const row of selectedRows) {
              const { original } = row;
              await API.put(
                "MoneyHubAdmin",
                `/leasing/reserve/${original.request_id}`,
                {
                  body: {
                    reserveBy: typeReserve === "cancel" ? "-" : user.username,
                  },
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );
            }
          } catch (error) {
            await EmitterStatus("ERROR", { logMessage: error });
          }
        },
      });
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await refetch(formQuery, true);
      setSelectedRows([]);
    } catch (error) {
      await EmitterStatus("ERROR", { logMessage: error });
    } finally {
      setLoadingReserve(false);
    }
  };

  return (
    <div className="flex flex-row">
      <div className="w-52">
        <Select
          defaultValue={RESERVE_OPTIONS[2]}
          value={formQuery.reserveBy}
          options={RESERVE_OPTIONS}
          onChange={onChangeSelect("reserveBy")}
        />
      </div>

      {checkRole(user?.groups, [
        "SuperAdmin",
        "ApproveSupervisor",
        "AnalyzeApprove",
        "ApproveStaff",
      ]) && (
        <React.Fragment>
          <button
            disabled={!selectedRows.length || loadingReserve}
            className={classNames(
              "ml-2 border p-1 px-2 rounded w-24 duration-300",
              {
                "bg-gray-300 cursor-not-allowed text-white":
                  !selectedRows.length || loadingReserve,
                "border-yellow-400 p-1 px-2 rounded text-white hover:bg-yellow-600 bg-yellow-400  hover:text-white":
                  selectedRows.length && !loadingReserve,
              }
            )}
            onClick={onClickReserve("reserve")}
          >
            จอง
          </button>
          <button
            disabled={!selectedRows.length || loadingReserve}
            className={classNames(
              "ml-2 border p-1 px-2 rounded w-24 duration-300",
              {
                "bg-gray-300 cursor-not-allowed text-white":
                  !selectedRows.length || loadingReserve,
                "border-yellow-400 p-1 px-2 rounded text-yellow-400 hover:bg-yellow-400 hover:text-white":
                  selectedRows.length && !loadingReserve,
              }
            )}
            onClick={onClickReserve("cancel")}
          >
            ยกเลิกจอง
          </button>
        </React.Fragment>
      )}
    </div>
  );
}

export default FootageReserve;
